import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip } from '@mui/material';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { useState } from 'react';
import download from "../../assets/images/excel.png";

export const ExportExcel =({excelData,fileName}) =>{
    const [open, setOpen] = useState(false);

    const fileType='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension ='.xlsx';

    const handleExportExcel = async () => {
        
        const wb = XLSX.utils.book_new();
    
        // Loop through excelData and create a new worksheet for each key in the key object
        excelData.forEach(({ data, key }) => {
          const ws = XLSX.utils.json_to_sheet(data);
          if (data.length !== 0) {
            XLSX.utils.book_append_sheet(wb, ws, key);
          } else if(wb.SheetNames.length ===0) {
            setOpen(true);
          }
        });
    
        // Write the workbook to a buffer and save it as a file
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(blob, fileName + fileExtension);
      };

    const handleClose = () => {
      setOpen(false);
    }
    
    return (
      <>
        <Tooltip title="Excel Export ">
          <Button className="chart-action-button" onClick={handleExportExcel}> 
            <img src={download} alt="Excel export"/>
            Excel
          </Button>
        </Tooltip>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>No data found</DialogTitle>
          <DialogContent>
            <DialogContentText>
              There is no data available to export. Please try again later.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>OK</Button>
          </DialogActions>
        </Dialog>
      </>
    )
}
